import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const WORDS = ["Residential", "Interiors", "Commercial", "Fit-outs"];

export default function DisciplineSwitch() {
  const reduce = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const [i, setI] = useState(0);
  useEffect(() => {
    if (reduce) return;
    const t = setInterval(() => setI((p) => (p + 1) % WORDS.length), 2400);
    return () => clearInterval(t);
  }, [reduce]);

  if (reduce) return <span className="italic">Residential</span>;

  return (
    <span
      data-testid="discipline-switch"
      className="relative inline-grid overflow-hidden italic whitespace-nowrap align-baseline leading-[inherit] pr-[0.18em]"
    >
      {/* Invisible phantoms — every word is stacked in the same 1x1 grid cell,
          so the container naturally grows to the widest word's true rendered
          width (not char-count). Each phantom sits at [1/1] so the grid stack. */}
      {WORDS.map((w) => (
        <span
          key={`phantom-${w}`}
          aria-hidden
          className="invisible"
          style={{ gridArea: "1 / 1" }}
        >
          {w}
        </span>
      ))}
      {/* Visible animating word — sits in the same grid cell, so it inherits
          the row/column baseline of the phantoms. */}
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={WORDS[i]}
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "-100%", opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          style={{ gridArea: "1 / 1" }}
        >
          {WORDS[i]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
